var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { H2 } from "@irati/ui/src/Headings";
import RewardAvatar from "./RewardAvatar";
var Header = styled.header(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin-top: -80px;\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-top: -80px;\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex-direction: row;\n    margin-top: 0;\n  "], ["\n    flex-direction: row;\n    margin-top: 0;\n  "])));
});
var Wrap = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  justify-content: space-between;\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  justify-content: space-between;\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-direction: column;\n    justify-content: flex-start;\n  "], ["\n    flex-direction: column;\n    justify-content: flex-start;\n  "])));
});
var RewardDetail = /** @class */ (function (_super) {
    __extends(RewardDetail, _super);
    function RewardDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RewardDetail.prototype.render = function () {
        var _a = this.props, thumbnailImage = _a.thumbnailImage, title = _a.title;
        return (React.createElement(Header, null,
            React.createElement(RewardAvatar, { thumbnailImage: thumbnailImage }),
            React.createElement(Wrap, null,
                React.createElement(H2, null, title))));
    };
    return RewardDetail;
}(PureComponent));
export default RewardDetail;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
